import React, { useState, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { Header } from "@components/templates";
import { AppLoader } from "@genie-ui/react";
import { ActisReporting } from "@utils/actisReporting";
import { Constants } from "@constants";
import {
  createStateSubscription,
  destroyStateSubscription,
} from "@gartner/genie-messenger-util";
import { autoLogout, redirectToLogin } from "@utils/Logout";

import "./app.scss";

const App = () => {
  const [currentUser, setCurrentUser] = useState();
  useEffect(() => {
    const subscriptionDetails = createStateSubscription("login", (data) => {
      setCurrentUser(data);
      autoLogout();
    });

    const handlePageShow = () => {
      if (localStorage.getItem(Constants.LOGOUT_EVENT_KEY) === "true") {
        redirectToLogin();
      }
    };

    window.addEventListener("pageshow", handlePageShow);
    return () => {
      destroyStateSubscription(subscriptionDetails);
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);
  ActisReporting.prototype.binder = { ...currentUser };

  if (!currentUser) {
    return <AppLoader />;
  }
  return (
    <>
      <BrowserRouter basename={Constants.ROUTES.BASE_URL}>
        <div></div>
        <div
          style={{
            position: "relative",
          }}
        >
          <Header currentUser={currentUser} />
        </div>
      </BrowserRouter>
    </>
  );
};

export default App;
